<!--
    file type .....: HTML file: match.component.html
    Created By ....: ianday
    Date ..........: 11/14/23 
-->
<div class="match-container">
    <div class="local-top-section">
        <div class="dwform">
            <div class="dwform-row-gap"></div>

            <label class="label-field">Case Information:</label>
            <span class="form-required"> </span>
            <label class="label-field-data">{{this.serviceRequest?.caseNumber}} -
                {{this.serviceRequest?.caseName}}</label>

            <!-- Request Type --->
            <div class="dwform-row-gap"></div>

            <label class="label-field">Request Type:</label>
            <span class="form-required"> </span>
            <label class="label-field-data">{{this.serviceRequest?.serviceRequestDesc}}</label>

            <div class="dwform-row-gap"></div>

            <!-- Current Matched Agency  --->

            <label class="label-field">Matched Agency:</label>
            <span class="form-required"> </span>
            <label class="label-field-data">{{currentAgency}}</label>

            <div class="dwform-row-gap"></div>

            <!-- Current Matched Zip code:  --->

            <label class="label-field">Zip / County:</label>
            <span class="form-required"> </span>
            <label class="label-field-data">{{this.serviceRequest?.zipCode}}</label>

            <div class="dwform-row-gap"></div>

            <mat-divider></mat-divider>
            <div class="dwform-row-gap"></div>
        </div>

        <div class="table-container mat-elevation-z2" (keydown)="tableKeyDown($event)" tabindex="-1">
            <table  *ngIf="assignOption==='any'" mat-table [dataSource]="dataSource" style="width:100%; border:none;" 
            	[class.disabled-table]="!assignToAnyAgency && !assignToMyAgency">

                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef
                        class="mat-table-header-style" [hidden]="true"></th>
                    <td mat-cell *matCellDef="let element" class="table-row-class" [hidden]="true"
                        class="width: 6px">
                        {{element.id}} </td>
                </ng-container>

                <ng-container matColumnDef="agencyName">
                    <th mat-header-cell *matHeaderCellDef
                        class="mat-table-header-style" style="width: 100px"> Agency </th>
                    <td mat-cell *matCellDef="let element" class="table-row-class"
                        style="width: 50%">
                        {{element.agencyName}} </td>
                </ng-container>

                <ng-container matColumnDef="serviceDescription" >
                    <th mat-header-cell *matHeaderCellDef style="width: 100px"
                        class="mat-table-header-style"> Service Description </th>
                    <td mat-cell *matCellDef="let element" class="table-row-class">
                        {{element.serviceDescription}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row
                    *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                    [ngClass]="{'row-selected': tableRowIdx == Idx}"
                    (click)="onRowClicked(row)">
                </tr>
            </table>
             <table  *ngIf="assignOption==='my'" mat-table [dataSource]="dataSource" style="width:100%; border:none;">

                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef
                        class="mat-table-header-style" [hidden]="true"></th>
                    <td mat-cell *matCellDef="let element" class="table-row-class" [hidden]="true"
                        class="width: 6px">
                        {{element.id}} </td>
                </ng-container>

                <ng-container matColumnDef="agencyName">
                    <th mat-header-cell *matHeaderCellDef
                        class="mat-table-header-style" style="width: 100px"> My Agency </th>
                    <td mat-cell *matCellDef="let element" class="table-row-class"
                        style="width: 50%">
                        {{element.agencyName}} </td>
                </ng-container>

                <ng-container matColumnDef="serviceDescription" >
                    <th mat-header-cell *matHeaderCellDef style="width: 100px"
                        class="mat-table-header-style"> Service Description </th>
                    <td mat-cell *matCellDef="let element" class="table-row-class">
                        {{element.serviceDescription}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row
                    *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                    [ngClass]="{'row-selected': tableRowIdx == Idx}"
                    (click)="onRowClicked(row)">
                </tr>
            </table>
           </div>

            <!-- checkbox for un-match -->
        <div class="dwform-row-gap"></div>

        <mat-checkbox binary="true" *ngIf="visibleUnAssignBtn && matched"
                      [ngStyle]="{ 'color': (matched === false) ? 'lightgray' : 'black'}"
                      (change)="doUnAssignCheckBoxChange($event)"
                      [(ngModel)]="unAssignFlag"
                      [ngModelOptions]="{standalone: true}">Unassign this request</mat-checkbox>

        <div style="height:18px" *ngIf="!visibleUnAssignBtn"></div>

        <div class="dwform-row-gap"></div>

       </div>

    <!----------------------->
    <!-- ERROR LINE --------->
    <!----------------------->
    <div class="error-line" [hidden]='!strErr.length'
         style="text-align:left; bottom:53px; left: 15px;">{{strErr}}</div>
    <!----------------------->
    <!-- SAVE STRIP        -->
    <!----------------------->
    <div style="text-align:center; margin-top: 3px;">
        <button class="command-button" [disabled]="!enableSubmit"
                (click)="onSubmitClicked()" matTooltip="Submit / save this entry"
                mat-button>
            <mat-icon>check_circle_outline</mat-icon>
            Submit
        </button>
        <button class="command-button" [disabled]="!enableCancel"
                (click)="onCancelClicked()" matTooltip="Cancel without saving this entry"
                mat-button>
            <mat-icon>highlight_off</mat-icon>
            Cancel
        </button>
    </div>

</div>
<p-dialog header="Confirm Email" [(visible)]="displayEmailConfirmation"
    [modal]="true" [style]="{width: '420px'}" appendTo="body"
    [draggable]="false" [resizable]="false" [closable]="true">
    <app-message-box #msgBox
        [data]="{message: 'Do you want to send an email?', showYes: true, showNo: true}"
        (onClose)="onEmailConfirm($event)">
    </app-message-box>
</p-dialog>